module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"continueQuiz":"Fullfør quiz"},"en":{"continueQuiz":"Complete the quiz"}}')
  delete Component.options._Ctor
}
